'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {sectionModel} from "../../models/sectionmodel.js";
import {participantModel} from "../../models/participantmodel.js";
import {wpModel} from "../../models/wpmodel.js";
import {riskModel} from "../../models/riskmodel.js";

export class SectionB2QualityCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'b2_quality_before',
			on: false,
			value: null
		},
		teams: {
			key: 'b2_3_project_teams_before',
			on: false,
			value: null
		},
		risk: {
			key: 'b2_6_risk_before',
			on: false,
			value: null
		}
	};
	participants = [];
	team = [];
	risk = [];

	$mdDialog;

	sections2Collect = ['b2_1_concept', 'b2_2_consortium', 'b2_4_quality_assurance', 'b2_5_cost_effectiveness', 'b2_7_ethics'];

	constructor($scope, $filter, jsDataService, $mdDialog){
		super($scope, $filter, jsDataService);
		this.$mdDialog = $mdDialog;
		if(typeof(this.section.childs) !== 'undefined'){
			this.initChildSections(this.section.childs);
		}
		if(typeof(this.section.participants) !== 'undefined'){
			this.initParticipants(this.section.participants);
		}
		this.initTeam();
		if(typeof(this.section.wp) !== 'undefined'){
			this.initWP(this.section.wp);
		}
		this.initRisk();
	}

	$onInit(){
		for(let sect in this.childSections){
			if(typeof(this.childSections[sect].instructions) !== 'undefined'){
				for(let prop in this.text){
					if(typeof(this.childSections[sect].instructions[this.text[prop].key]) !== 'undefined' && this.childSections[sect].instructions[this.text[prop].key].value !== ''){
						this.text[prop].on = true;
						this.text[prop].value = this.childSections[sect].instructions[this.text[prop].key].value;
					}
				}
			}
		}
	}

	initParticipants(participants){
		for(let participant of participants){
			this.participants.push(new participantModel(participant, this.$filter, this.jsDataService));
		}
	}

	initTeam(){
		this.team = [];
		if(typeof(this.section.team) !== 'undefined'){
			for(let team of this.section.team){
				team.b2_3_project_teams_participant_title = '';
				if(team.b2_3_project_teams_participant){
					let plist = this.$filter('filter')(this.participants, {id: team.b2_3_project_teams_participant}, true);
					if(plist.length > 0){
						team.b2_3_project_teams_participant_title = plist[0].getValue('a3_participants_acronym');
					}
				}
				else{
					team.b2_3_project_teams_participant = '0';
				}
				if(typeof(team.rows) === 'undefined' || team.rows.length < 1){
					team.rows = [];
				}
				if(team.rows.length < 1){
					team.rows.push({
						id: team.id,
						b2_3_project_teams_name: '',
						b2_3_project_teams_role: '',
						b2_3_project_teams_profile: ''
					});
				}

				let rownr = 0;
				for(let row of Object.values(team.rows)){
					if(rownr < 1){
						row.id = team.id,
						row.b2_3_project_teams_participant = team.b2_3_project_teams_participant;
						row.b2_3_project_teams_participant_title = team.b2_3_project_teams_participant_title;
						row.b2_3_project_teams_presentation = team.b2_3_project_teams_presentation;
						row.rowspan = Object.values(team.rows).length;
					}
					rownr++;
					this.team.push(row);
				}
			}
		}
	}

	initWP(workpackages){
		this.workpackages = [];
		for(let wp of workpackages){
			wp.title = wp.a4_1_work_activities_no;
			this.workpackages.push(new wpModel(wp, this.$filter, this.jsDataService));
		}
		let classif = this.jsDataService.get('cfgClassif');
		classif.wp = this.workpackages;
//		this.jsDataService.set('cfgClassif', classif);
	}

	initRisk(){
		this.risk = [];
		if(typeof(this.section.risk) !== 'undefined'){
			for(let risk of this.section.risk){
				risk.wp_title = '';
				if(typeof(risk.wp_ids) === 'object'){
					let titleCollection = [];
					for(let wpid of Object.values(risk.wp_ids)){
						let wpList = this.$filter('filter')(this.workpackages, {id: wpid}, true);
						if(wpList.length > 0){
							titleCollection.push(wpList[0].getValue('wptitle'));
						}
					}
					if(titleCollection.length > 0){
						risk.wp_title = titleCollection.join(', ');
					}
				}
				this.risk.push(new riskModel(risk, this.$filter, this.jsDataService));
			}
		}
	}

	removeTeamMember(ev, teamMember){
		if(this.jsDataService.get('cfgTeamRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('teamRemoveConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgTeamRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: teamMember.id
					}
				}).then((results) => {
					if(results.data.success){
						this.section.team = this.$filter('filter')(this.section.team, {id: '!'+teamMember.id}, true);
						this.initTeam();
					}
				});
			}, () => {});
		}
	}

	removeRisk(ev, risk){
		if(this.jsDataService.get('cfgRiskRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('riskRemoveConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRiskRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: risk.id
					}
				}).then((results) => {
					if(results.data.success){
						this.section.risk = this.$filter('filter')(this.section.risk, {id: '!'+risk.id}, true);
						this.initRisk();
					}
				});
			}, () => {});
		}
	}

	addTeamMember(ev){
		this.teamMemberEditor(ev, {});
	}

	editTeamMember(ev, teamMember){
		this.teamMemberEditor(ev, teamMember);
	}

	teamMemberEditor(ev, member){
		let teamMember = {
			id: 0,
			ord: this.section.team.length,
			b2_3_project_teams_participant: '',
			b2_3_project_teams_participant_title: '',
			b2_3_project_teams_presentation: '',
			rows: []
		};
		if(typeof(member.id) !== 'undefined' && member.id > 0){
			let ff = this.$filter('filter')(this.section.team, {id: member.id}, true);
			if(ff.length > 0){
				teamMember = ff[0];
			}
		}
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "teamMember", "section", "fieldCfg", "participants", this.teamMemberEditorDialogCtrl],
			templateUrl: 'application/team_member_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				teamMember: teamMember,
				section: this.section,
				fieldCfg: this.fieldCfg,
				participants: this.participants
			}
		}).then((memberItem) => {
			if(this.jsDataService.get('cfgTeamSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgTeamSaveUrl'),
					method: 'POST',
					data: memberItem
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						if(teamMember.id > 0){
							teamMember = angular.extend(teamMember, response.data.item);
						}
						else{
							this.section.team.push(response.data.item);
						}
						this.initTeam();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgTeamSaveUrl'));
			}
		}, () => {});
	}

	addRisk(ev){
		const maxOrd = this.risk.reduce((max, r) => Math.max(max, parseInt(r.ord || 0)), -1);
		this.riskEditor(ev, new riskModel({
			id: 0,
			ord: maxOrd + 1,
			b2_6_risk_no: (this.risk.length+1),
			b2_6_risk_description: '',
			b2_6_risk_mesures: '',
			b2_6_risk_probability: '0',
			wp_ids: [],
		}, this.$filter, this.jsDataService));
	}

	editRisk(ev, risk){
		this.riskEditor(ev, risk);
	}

	riskEditor(ev, risk){

		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "risk", "section", "fieldCfg", this.riskEditorDialogCtrl],
			templateUrl: 'application/risk_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				risk: risk,
				section: this.section,
				fieldCfg: this.fieldCfg,
			}
		}).then((riskItem) => {
			if(this.jsDataService.get('cfgRiskSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRiskSaveUrl'),
					method: 'POST',
					data: riskItem
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						if(risk.id > 0){
							risk = angular.extend(risk, response.data.item);
							if(typeof(risk.id) !== 'undefined' && risk.id > 0){
								let ff = this.$filter('filter')(this.section.risk, {id: risk.id}, true);
								if(ff.length > 0){
									let sectionRisk = ff[0];
									sectionRisk = angular.extend(sectionRisk, response.data.item);
								}
							}
						}
						else{
							this.section.risk.push(response.data.item);
							this.initRisk();
						}
//						this.initRisk();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgRiskSaveUrl'));
			}
		}, () => {});
	}

	teamMemberEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, teamMember, section, fieldCfg, participants){
		$scope.member = angular.copy(teamMember);
		$scope.participants = participants;
		$scope.fieldCfg = fieldCfg;
		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};
		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.isValid = function(){
			return (!$scope.fieldRequire('b2_3_project_teams_participant') || $scope.member.b2_3_project_teams_participant > 0);
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};

		$scope.rowFieldName = function(index, name){
			return 'r'+index+'_'+name;
		};

		$scope.removeRow = function(rowIndex){
			$scope.member.rows.splice(rowIndex, 1);
		};

		$scope.addRow = function(){
			$scope.member.rows.push({
				b2_3_project_teams_name: '',
				b2_3_project_teams_role: '',
				b2_3_project_teams_profile: ''
			});
		};
		function init(){
			if(typeof($scope.member.rows.splice) !== 'function'){
				$scope.member.rows = Object.values($scope.member.rows);
			}
			if($scope.member.rows.length < 1){
				$scope.addRow();
			}
		}
		init();
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.member);
		};
	}

	riskEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, risk, section, fieldCfg){
		$scope.risk = angular.copy(risk);
		let classif = jsDataService.get('cfgClassif');
		$scope.wps = classif.wp;
		$scope.risklevel = classif.risk;
		$scope.fieldCfg = fieldCfg;
		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};
		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.isValid = function(){
			return true;
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};
		$scope.checkEmpty = function(name){
			if($scope.risk[name] === '0' || $scope.risk[name] === ''){
				$scope.riskForm[name].$setValidity('required', false);
			}
		};


		function init(){
			setTimeout(() => {
				if($scope.risk.b2_6_risk_probability === '0' || $scope.risk.b2_6_risk_probability === ''){
					$scope.riskForm.b2_6_risk_probability.$setValidity('required', false);
				}
			});
		}
		init();
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.risk.getData());
		};
	}

	autosavePostFields(){
		let post = [];

		for(let section of this.sections2Collect){
			if(this.childSections[section] instanceof sectionModel){
				for(let fkey in this.childSections[section].fieldMap){
					post.push(this.childSections[section].fieldMap[fkey].getData());
				}
			}
		}

		return post;
	}
}

